import { useState, useMemo } from 'react'
import { applyFilters, extractFilterValues, splitByDate } from '../utils/filters'

const useReminderFilters = (data) => {
  const [searchText, setSearchText] = useState('')
  const [categoryFilter, setCategoryFilter] = useState('all')
  const [priorityFilter, setPriorityFilter] = useState('all')
  const [acknowledgedFilter, setAcknowledgedFilter] = useState('all')

  // Extract filter values from data
  const filterValues = useMemo(() => extractFilterValues(data), [data])

  // Apply filters to data
  const filteredData = useMemo(() => {
    return applyFilters(data, {
      searchText,
      categoryFilter,
      priorityFilter,
      acknowledgedFilter
    })
  }, [data, searchText, categoryFilter, priorityFilter, acknowledgedFilter])

  // Split filtered data by date
  const { upcomingReminders, pastReminders } = useMemo(() => {
    return splitByDate(filteredData)
  }, [filteredData])

  return {
    // Filter values
    filterValues,
    // Filter states
    searchText,
    setSearchText,
    categoryFilter,
    setCategoryFilter,
    priorityFilter,
    setPriorityFilter,
    acknowledgedFilter,
    setAcknowledgedFilter,
    // Filtered data
    filteredData,
    upcomingReminders,
    pastReminders
  }
}

export default useReminderFilters
